module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./CommissionView.js"));
	}, "CommissionView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CommissionView!./src/pages/Promote/Achievement/Commission/CommissionView.js
// module id = 1663
// module chunks = 418